<template>
	<transition name="menushow">
		<div class="setting-menu" v-show="visible">
			<el-tabs v-model="activeName" class="setting-menu-tabs">
				<el-tab-pane label="显示列" name="0">
					<div style="overflow-y: auto;">
						<el-checkbox v-model="allChooseShow" class="save-default all-choose-in" @change="handleCheckAllChangeShow">全选</el-checkbox>
						<el-checkbox-group v-model="currentShowCol" class="clearfix">
							<el-checkbox
								v-for="item in colData"
								:key="item.prop"
								:label="item.prop"
								:disabled="item.disabled"
								class="checkbox-item">{{item.label}}
							</el-checkbox>
						</el-checkbox-group>
					</div>

				</el-tab-pane>
				<el-tab-pane label="冻结列" name="1">
					<div style="overflow-y: auto;">
						<el-checkbox v-model="allChooseFrozen" class="save-default all-choose-in" @change="handleCheckAllChangeFrozen">全选</el-checkbox>
						<el-checkbox-group v-model="currentFrozenCol" class="clearfix">
							<el-checkbox
								v-for="item in colData"
								:key="item.prop"
								:label="item.prop"
								class="checkbox-item">{{item.label}}
							</el-checkbox>
						</el-checkbox-group>
					</div>

				</el-tab-pane>
			</el-tabs>
			<div class="setting-menu-btns">
				<div class="menu-row">
					<span>方案名称：</span>
					<el-input
						v-model="planName"
						class="menu-input"
						placeholder="请输入方案名称"
						size="small">
					</el-input>
				</div>
				<div class="menu-row">
					<span>选择方案：</span>
					<el-select
						v-model="currentPlanSelect"
						@change="planChange"
						placeholder="请选择方案"
						class="menu-input"
						size="small">
						<el-option
							v-for="(item) in planOptions"
							:key="item.id"
							:label="item.schemename"
							:value="item.id">
						</el-option>
					</el-select>
					<el-checkbox v-model="saveDefaultFlag" class="save-default">保存默认</el-checkbox>
				</div>
				<div class="menu-btn-row">
					<el-button
						type="primary"
						plain
						size="small"
						class="menu-btn"
						:disabled="saveasDisable"
						@click="saveasHandler">另存方案</el-button>
					<el-button
						type="primary"
						plain
						size="small"
						class="menu-btn"
						:disabled="planDisable"
						@click="saveHandler">保存编辑</el-button>
					<el-button
						type="danger"
						size="small"
						:disabled="planDisable"
						class="menu-btn"
						@click="deleteClick">删除方案</el-button>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
// import { mapState } from 'vuex'
export default {
	name: 'SettingMenu',
	props: {
		reportid: String,
		visible: Boolean,
		planSelect: String,
		colData: {
			type: Array,
			default: () => []
		},
		planOptions: {
			type: Array,
			default: () => []
		},
		settingCols: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			currentPlan: {},
			currentPlanSelect: this.planSelect,
			currentShowCol: [],
			currentFrozenCol: [],
			allChooseShow: true,
			allChooseFrozen: false,
			activeName: '0',
			planName: '',
			saveDefaultFlag: false
		}
	},
	watch: {
		planSelect: {
			handler (val) {
				this.currentPlanSelect = val
			},
			immediate: true
		},
		currentPlanSelect: {
			handler (val) {
				if (val === null ||
					val === undefined) {
					this.currentPlan = {}
					this.planName = ''
					this.$emit('updataCol', this.settingCols)
					var arr = []
					for (var i = 0; i < this.colData.length; i++) {
						if (this.colData[i].ischoose) {
							arr.push(this.colData[i].prop)
						}
					}
					this.currentShowCol = arr
					this.currentFrozenCol = []
					this.saveDefaultFlag = false
					if (this.colData.length !== this.currentShowCol.length) {
						this.allChooseShow = false
					} else {
						this.allChooseShow = true
					}
				} else {
					this.planOptions.forEach(item => {
						if (item.id === val) {
							this.currentPlan = item
						}
					})
					this.planName = this.currentPlan.schemename
					var schemetext = JSON.parse(this.currentPlan.schemetext)
					let propArr = this.settingCols.map(item => {
						return item.prop
					})
					let copyCols = this.$fxUtils.deepClone(this.settingCols)
					// 复选框选中项
					var arr1 = []
					var colArr = []
					schemetext.viewcols.forEach(item => {
						if (item.showFlag) {
							arr1.push(item.prop)
						}
						if (propArr.includes(item.prop)) {
							colArr.push(item)
							let copyIndex = copyCols.findIndex(copyItem => {
								return copyItem.prop === item.prop
							})
							copyCols.splice(copyIndex, 1)
						}
					})
					this.currentShowCol = arr1 || []
					this.currentFrozenCol = schemetext.frozencols ? schemetext.frozencols : []
					this.saveDefaultFlag = this.currentPlan.defaultflag === 1
					this.$emit('updataCol', colArr.concat(copyCols))
				}
				this.$emit('update:planSelect', val)
			},
			immediate: true
		},
		currentShowCol (checkcol, oldvalue) {
			let empty2full = this.colData.length === checkcol.length && oldvalue.length === 0
			this.colData.forEach(item => {
				if (checkcol.includes(item.prop)) {
					item.showFlag = true
				} else {
					item.showFlag = false
				}
			})
			if (this.colData.length !== checkcol.length) {
				this.allChooseShow = false
			} else {
				this.allChooseShow = true
			}
			this.$emit('update:colData', this.colData)
			this.$emit('changeShowColData', [checkcol, empty2full])
		},
		currentFrozenCol (checkcol, oldvalue) {
			let empty2full = this.colData.length === checkcol.length && oldvalue.length === 0
			this.colData.forEach(item => {
				if (checkcol.includes(item.prop)) {
					item.fixed = true
				} else {
					item.fixed = false
				}
			})
			if (this.colData.length !== checkcol.length) {
				this.allChooseFrozen = false
			}
			this.$emit('update:colData', this.colData)
			this.$emit('changeFrozenColData', [checkcol, empty2full])
		}
	},
	computed: {
		// ...mapState([
		// 	'reportid'
		// ]),
		planDisable () {
			if (this.planOptions.length === 0 ||
				this.planSelect === null ||
				this.planSelect === undefined) {
				return true
			} else {
				return false
			}
		},
		saveasDisable () {
			if (this.planName === '' ||
				this.planName === this.currentPlan.schemename) {
				return true
			} else {
				return false
			}
		}
	},
	created () {
		this.checkSmallCategory()
	},
	methods: {
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				let colData = this.colData
				if (res.matchbillcenterflag === 0) {
					const index = colData.findIndex(item => {
						return item.prop === 'systemmemo'
					})
					if (index !== -1) {
						colData.splice(index, 1)
					}
					this.$emit('update:colData', colData)
				}
				if (res.showgift === 0) {
					const index = colData.findIndex(item => {
						return item.prop === 'refundGiftPreMoney'
					})
					if (index !== -1) {
						colData.splice(index, 1)
					}
					const index2 = colData.findIndex(item => {
						return item.prop === 'orderGiftPreMoney'
					})
					if (index2 !== -1) {
						colData.splice(index2, 1)
					}
					const index3 = colData.findIndex(item => {
						return item.prop === 'costMoney'
					})
					if (index3 !== -1) {
						colData.splice(index3, 1)
					}
					const index4 = colData.findIndex(item => {
						return item.prop === 'giftMoney'
					})
					if (index4 !== -1) {
						colData.splice(index4, 1)
					}
					colData.forEach(item => {
						if (item.prop === 'orderPreMoney') {
							item.label = '预付货款交易金额'
						}
						if (item.prop === 'refundPreMoney') {
							item.label = '预付货款退款金额'
						}
					})
					this.$emit('update:colData', colData)
				}
			})
		},
		planChange () {
			this.$emit('planChange')
		},
		handleCheckAllChangeShow (val) {
			if (val) {
				this.currentShowCol = this.colData.map(item => {
					return item.prop
				})
			} else {
				this.currentShowCol = this.colData.filter(item => {
					return item.disabled
				}).map(item => {
					return item.prop
				})
				// this.currentShowCol = []
			}
		},
		handleCheckAllChangeFrozen (val) {
			if (val) {
				this.currentFrozenCol = this.colData.map(item => {
					return item.prop
				})
			} else {
				this.currentFrozenCol = []
			}
		},
		getSettingParams () {
			return {
				viewcols: this.currentShowCol,
				frozencols: this.currentFrozenCol
			}
		},
		getViewcols () {
			var arr = []
			this.colData.forEach(item => {
				if (item.showFlag) {
					arr.push(item.prop)
				}
			})
			return arr
		},
		checkParam () {
			var name = this.planName.trim()
			if (name === '') {
				this.$message.error('方案名称不能为空')
				return false
			}
			if (name.split('').length > 50) {
				this.$message.error('方案名称不能超过50个字!')
				return false
			}
			if (this.getViewcols().length === 0) {
				this.$message.error('请勾选显示列!')
				return false
			}
			return true
		},
		saveasHandler () {
			if (!this.checkParam()) {
				return false
			}
			let widthArr = []
			this.$emit('getWidth', data => {
				widthArr = data
			})
			let colData = this.colData
			let index = 0
			colData.forEach(item => {
				if (item.showFlag) {
					item.width = widthArr[index]
					index++
				}
			})
			var name = this.planName.trim()
			let param = {
				id: '0',
				defaultflag: this.saveDefaultFlag ? 1 : 0,
				reportid: this.reportid,
				schemename: name,
				schemetext: {
					viewcols: colData,
					frozencols: this.currentFrozenCol
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/reportScheme/saveOrUpdateReportScheme`,
				data: param
			}).then(res => {
				if (res.result) {
					this.$message({
						message: `新增方案【${this.planName}】成功!`,
						type: 'success'
					})
					this.$emit('savePlanResolve')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveHandler () {
			var name = this.planName.trim()
			if (!this.checkParam()) {
				return false
			}
			let widthArr = []
			this.$emit('getWidth', data => {
				widthArr = data
			})
			let colData = this.colData
			let index = 0
			colData.forEach(item => {
				if (item.showFlag) {
					item.width = widthArr[index]
					index++
				}
			})
			let param = {
				id: this.currentPlan.id,
				defaultflag: this.saveDefaultFlag ? 1 : 0,
				reportid: this.reportid,
				schemename: name,
				schemetext: {
					viewcols: colData,
					frozencols: this.currentFrozenCol
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/reportScheme/saveOrUpdateReportScheme`,
				data: param
			}).then(res => {
				if (res.result) {
					this.$message({
						message: `保存方案【${this.planName}】成功!`,
						type: 'success'
					})
					this.$emit('savePlanResolve')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteClick () {
			this.$confirm('是否删除该方案？', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			}).then(() => {
				this.deleteHandler()
			}).catch(() => {
			})
		},
		deleteHandler () {
			let param = {
				id: this.currentPlan.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/reportScheme/delReportScheme`,
				data: param
			}).then(res => {
				this.$message({
					message: `删除方案【${this.planName}】成功!`,
					type: 'success'
				})
				var num = null
				this.planOptions.forEach((item, index) => {
					if (item.id === this.planSelect) {
						num = index
					}
				})
				this.planOptions.splice(num, 1)
				this.currentPlanSelect = null
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.menushow-enter-active {
	transition: all .3s ease;
}
.menushow-leave-active {
	transition: all .3s ease;
}
.menushow-enter, .menushow-leave-to {
	transform:translateX(-100%)
}
.setting-menu {
	overflow: auto;
	flex-shrink: 0;
	display :flex;
	flex-direction :column;
	height:100%
	width:380px
	padding-left: 20px;
	border-right:1px solid #eee
	.setting-menu-tabs {
		font-size:14px;
		flex:1;
		overflow: auto;
		height: 100%;
		.checkbox-item {
			width:50%
			margin-left:0
			margin-bottom:10px
			margin-right:0
			text-align:left
			float: left
		}
		.all-choose-in{
			float: left;
			margin-bottom: 10px;
		}
		.clearfix{
			clear: both;
		}
	}
	.setting-menu-btns {
		height :165px;
		text-align:left
		font-size:14px
		margin-top: 50px
		.menu-row {
			margin-bottom:20px
			.menu-input {
				width:150px
			}
			.save-default {
				margin-left:20px
			}
		}
		.menu-btn-row {
			.menu-btn {
				width:110px
			}
		}
	}
}
</style>

